import React from "react";
import { Col, Container, Row, Button, Card } from "react-bootstrap";
import "./CardDetails.css";
import { BsArrowRight } from "react-icons/bs";

export default function CardDetails() {
  return (
    <Container className="card-details">
      <div>
        <h2>Courses & Programs</h2>
        <p>
          Subject areas where demand is high, competition is fierce, and talent
          is scarce.
        </p>
      </div>
      <Row>
        <Col lg={6}>
          <Card className="card-bod">
            <Card.Body>
              <Card.Title className="cards-details-title">
                Computer Science
              </Card.Title>
              <Card.Text>
                <span className="card-desc">Subject Areas Include:</span>
                <p>
                  {" "}
                  Data Structures, Programming Languages, Web & Mobile Design.
                  <br />
                  <br />
                </p>
              </Card.Text>
              <Button variant="primary">Browse Courses</Button>
              <Button variant="primary">Get Started</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="card-bod">
            <Card.Body>
              <Card.Title className="cards-details-title">
                Business Management
              </Card.Title>
              <Card.Text>
                <span className="card-desc">Subject Areas Include:</span>
                <p>
                  {" "}
                  Digital Strategy, Economics, Finance, Product Development,
                  Operations.
                </p>
              </Card.Text>
              <Button variant="primary">Browse Courses</Button>
              <Button variant="primary">Get Started</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="card-bod">
            <Card.Body>
              <Card.Title className="cards-details-title">
                Data & Analytics
              </Card.Title>
              <Card.Text>
                <span className="card-desc">Subject Areas Include:</span>
                <p>
                  {" "}
                  AI, Big Data, Machine Learning, Data Science, Python, SQL, C,
                  Java.
                  <br />
                  <br />
                </p>
              </Card.Text>
              <Button variant="primary">Browse Courses</Button>
              <Button variant="primary">Get Started</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="card-bod">
            <Card.Body>
              <Card.Title className="cards-details-title">
                Professional Skills
              </Card.Title>
              <Card.Text>
                <span className="card-desc">Subject Areas Include:</span>
                <p>
                  {" "}
                  Excel, Soft Skills, Inclusive Leadership & Other Key Business
                  Proficiencies.
                </p>
              </Card.Text>
              <Button variant="primary">Browse Courses</Button>
              <Button variant="primary">Get Started</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <div className="card-btn-s">
        <Button variant="primary">
          Courses For Teams <BsArrowRight />{" "}
        </Button>
      </div>
    </Container>
  );
}
